export const snacksTypes = {
     BURGER_TYPE_INCREASE : 'BURGER_TYPE_INCREASE',
     BURGER_TYPE_DECREASE : 'BURGER_TYPE_INCREASE_DECREASE',
     FRIES_TYPE_INCREASE : 'FRIES_TYPE_INCREASE',
     FRIES_TYPE_DECREASE : 'FRIES_TYPE_DECREASE',
     WRAP_TYPE_INCREASE : 'WRAP_TYPE_INCREASE',
     WRAP_TYPE_DECREASE : 'WRAP_TYPE_DECREASE',
     PIZZA_TYPE_INCREASE : 'PIZZA_TYPE_INCREASE',
     PIZZA_TYPE_DECREASE : 'PIZZA_TYPE_DECREASE',
     CLEAR_ALL_SNACKS : 'CLEAR_ALL_SNACKS'
}